// @ts-nocheck
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Container, Dropdown, Row, Col } from '@mch-group/uikit-components'
import styled from 'styled-components'
import { connect } from 'react-redux'
import qs from 'query-string'
import shortid from 'shortid'
import NoSSR from 'react-no-ssr'
import 'intersection-observer'

import cssClasses from '../../../constants/cssClasses'
import mq from '../../../utils/styled-mq'
import { FactsFigures as FactsFiguresService, Cms as CmsService } from '../../../services'
import { logger, apiResponseValidator, updateUrlParams } from '../../../utils'
import Text from '../../Text'
import Separator from '../../Separator'
import { getSiteLanguage } from '../../../utils/storage'
import NoResultsComponent from '../../NoResults'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'

const mID = 'otm-press-facts-figures'

class PressFactsFigures extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    apr_grp1_default_selected_tab: PropTypes.string,
    store: PropTypes.object,
    AltTags: PropTypes.object
  }

  constructor(props) {
    super(props)
    const {
      productId = props.apr_grp1_default_selected_tab ? parseInt(-props.apr_grp1_default_selected_tab, 0) : 0
    } = qs.parse(window.location.search)

    this.limit = 8
    this.state = {
      pressList: [],
      productId: productId ? parseInt(productId, 0) : 0,
      isLoading: true,
      hasMore: false,
      offset: 0
    }
  }

  async componentDidMount() {
    const options = {
      root: null, // Page as root
      rootMargin: '0px', // rootMargin must be specified in pixels or percent
      threshold: 0
    }
    // https://codesandbox.io/embed/ol40mzq9vq
    // Create an observer
    this.observer = new IntersectionObserver(
      this.handleObserver.bind(this), // callback
      options
    )

    try {
      const productsRequest = await CmsService.getProducts(getSiteLanguage())
      const pressList = await this.getFactsFigures()

      // validate the response and filter the items without name
      let productsList = []
      if (apiResponseValidator(productsRequest)) {
        productsList = productsRequest.data.items
        productsList = productsList.filter((item) => item.name !== undefined && item)
      }

      this.setState({
        productsList: this.prepareProductsforSelect(productsList),
        pressList,
        isLoading: false
      })
    } catch (e) {
      logger(e)
    }
  }

  componentWillUnmount() {
    this.observer.disconnect()
  }

  async getFactsFigures() {
    const params = {
      productId: this.state.productId,
      offset: this.state.offset,
      limit: this.limit,
      locale: getSiteLanguage(),
      ascending: true
    }
    const pressList = await FactsFiguresService.getFactsFigures(params)
    if (apiResponseValidator(pressList)) {
      // If there are more pages, enable the observer
      if (pressList.data.hasMore) {
        this.loadingRef && this.observer.observe(this.loadingRef)
      } else {
        this.loadingRef && this.observer.unobserve(this.loadingRef)
      }
      this.setState({
        hasMore: pressList.data.hasMore,
        total: pressList.data.total
      })
    }
    return pressList
  }

  handleChangeType = (value) => {
    if (value !== this.state.productId) {
      const params = {
        productId: value
      }
      updateUrlParams(params)
      params.isLoading = true
      params.offset = 0
      this.setState(params, () => this.updateList())
    }
  }

  async updateList() {
    const newPressList = await this.getFactsFigures()
    const pressList = { ...newPressList }
    if (this.state.offset > 0) {
      pressList.data.items = [...this.state.pressList.data.items, ...newPressList.data.items]
    }
    const newState = {
      pressList,
      isLoading: false
    }
    this.setState(newState)
  }

  requestNewPage = () => {
    this.setState(
      {
        offset: this.state.offset + this.limit
      },
      this.updateList
    )
  }

  prepareProductsforSelect = (productsList) => {
    const products = productsList.map((product) => ({
      key: product.id.toString(),
      value: product.id.toString(),
      label: product.name
    }))
    products.unshift({ key: shortid.generate(), value: 0, label: this.props.store.las_grp1_aff })
    return products
  }

  handleObserver(entities) {
    const { isIntersecting } = entities[0]
    if (isIntersecting) {
      this.requestNewPage()
    }
  }

  handleLoadingRef(loadingRef) {
    this.loadingRef = loadingRef
  }

  render() {
    const { pressList, total } = this.state
    const { store } = this.props

    return (
      <Container className={`px-5 px-lg-8 px-md-7 ${this.props.className} ${cssClasses.CMS_MODULE}`}>
        {/* filters */}
        <div className={mID}>
          <Container className={`${mID}__filters`}>
            <Row className='col-lg-4'>
              <Col computer={4} mobile={12}>
                <p className='text-label-xlarge mb-0'>{store.las_grp1_type_label || 'Type'}</p>
                {this.state.productsList && (
                  <Dropdown
                    placeholder={this.props.store.las_grp1_aff}
                    options={this.state.productsList}
                    value={this.state.productId && this.state.productId.toString()}
                    onChange={this.handleChangeType}
                    aria-label='pressFilterType'
                  />
                )}
              </Col>
            </Row>
          </Container>
        </div>

        {/* No results message */}
        {total === 0 && <NoResultsComponent entityid='PressContent' fieldName='noResultsWarning' isNested />}

        {/* List items */}
        {pressList && pressList.data && pressList.data.items && (
          <div className={`${mID}__output`}>
            <Container>
              {pressList.data.items.map((item) => (
                <Fragment key={item.id}>
                  <Row className={`${mID}__item`}>
                    <Col>
                      <Text isSmall forwardedAs='p' className={`${mID}__product`}>
                        {item.product && `${item.product.name} `}
                        {item.subProduct && `: ${item.subProduct}`}
                      </Text>
                      <h2 className='subtitle h3'>
                        {item.description && <Text className={`${mID}__desc`}>{item.description}</Text>}
                      </h2>
                      {item.documents && (
                        <Text isSmall forwardedAs='p' className={`${mID}__lang`}>
                          {store.las_grp1_download && <span>{store.las_grp1_download}</span>}
                          {item.documents.map((doc) => (
                            <a
                              href={doc.fileUrl}
                              target='_blank'
                              rel='nofollow noopener'
                              key={doc.id}
                              title={`${this.props.AltTags?.generalLinkPDFDocument || 'Link to PDF document'} | ${
                                item.description
                              } | ${doc.locale}`}
                            >
                              {doc.locale}
                            </a>
                          ))}
                        </Text>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Separator noMarginBottom />
                  </Row>
                </Fragment>
              ))}
            </Container>
          </div>
        )}
        {/* List loading */}
        {this.state.hasMore && !this.state.isLoading && (
          <Container>
            <Container centered>{/* <Loader inline active size='small' /> */}</Container>
          </Container>
        )}
        <div
          ref={(loadingRef) => {
            this.handleLoadingRef(loadingRef)
          }}
          // Edge needs the observed item to have some width and height
          style={{ height: '1px', width: '1px' }}
        />
      </Container>
    )
  }
}

const ConnectedPressFactsFigures = connect(
  ({ shared }) => ({ store: shared.globalModules.labelModule.labels }),
  null
)(PressFactsFigures)

const StyledFactsAndFigures = styled(ConnectedPressFactsFigures)`
  .${mID} {
    &__output {
      font-weight: ${tokens.fontWeights.artBaselHeadline0.value};
      margin-bottom: ${MFP.vars['40px']};
      ${mq.between('tablet', 'largestTablet')`
        margin-top: ${MFP.vars['60px']};
      `}
      ${mq.lessThan('largestMobile')`
        margin-top: ${MFP.vars['40px']};
      `}

      .ui.header.subtitle {
        font-weight: ${tokens.fontWeights.artBaselHeadline0.value};
      }
    }

    &__filters {
      margin-bottom: ${MFP.vars['35px']};
      ${mq.lessThan('desktop')`
        margin-bottom: 0;
      `}
      & > .ui.grid > .row {
        padding-top: 0;
        ${mq.lessThan('desktop')`
          padding-bottom: 0;
        `}
      }
    }

    &__item.row {
      padding-top: ${MFP.vars['42px']};
      padding-bottom: ${MFP.vars['40px']};
      ${mq.between('tablet', 'largestTablet')`
        padding-top: ${MFP.vars['42px']};
        padding-bottom: ${MFP.vars['40px']};
      `}
      ${mq.lessThan('largestMobile')`
        padding-top: ${MFP.vars['39px']};
        padding-bottom: ${MFP.vars['40px']};
      `}
      &:first-child {
        ${mq.between('tablet', 'largestTablet')`
          padding-top: ${MFP.vars['30px']};
        `}
        ${mq.lessThan('largestMobile')`
          padding-top: ${MFP.vars['20px']};
        `}
      }
    }

    &__product {
      margin-bottom: ${MFP.vars['7px']};
      ${mq.between('tablet', 'largestTablet')`
        margin-bottom: ${MFP.vars['18px']};
      `}
      ${mq.lessThan('largestMobile')`
        margin-bottom: ${MFP.vars['12px']};
      `}
    }

    &__desc {
      margin-bottom: ${MFP.vars['17px']};
      ${mq.between('tablet', 'largestTablet')`
        margin-bottom: ${MFP.vars['34px']};
      `}
      ${mq.lessThan('largestMobile')`
        margin-bottom: ${MFP.vars['23px']};
      `}
    }

    &__lang {
      margin-top: 0 !important;

      span {
        margin-right: ${MFP.vars['20px']};
      }

      a {
        margin-right: ${MFP.vars['13px']};
      }
    }
  }
`

const StyledFactsAndFiguresNoSSR = (props) => (
  <NoSSR>
    <StyledFactsAndFigures {...props} />
  </NoSSR>
)

export default StyledFactsAndFiguresNoSSR
